import styled, { css } from 'styled-components';
import { media } from 'src/components/base';
import { TabAnchor } from './types';

const REVIEWS_MIN_HEIGHT = '400px'; // Reviews section height with a title and no reviews

const STATISTICS_MIN_HEIGHT_DESKTOP_LEGACY = '625px'; // Height with top padding, but no ads
const STATISTICS_MIN_HEIGHT_DESKTOP = '470px'; // Height with top padding, but no ads
const STATISTICS_MIN_HEIGHT_MOBILE_LEGACY = '529px'; // Height with top padding and one ad
const STATISTICS_MIN_HEIGHT_MOBILE = '664px'; // Height with top padding, but no ads

export const SectionWrapper = styled.div<{
  id: TabAnchor;
  $isNewpriceHistory?: boolean;
}>(
  props => css`
    ${props.id === TabAnchor.REVIEWS &&
    css`
      min-height: ${REVIEWS_MIN_HEIGHT};
    `}

    ${props.id === TabAnchor.STATISTICS &&
    css`
      min-height: ${props.$isNewpriceHistory === true
        ? STATISTICS_MIN_HEIGHT_MOBILE
        : STATISTICS_MIN_HEIGHT_MOBILE_LEGACY};

      ${media.mediumUp`
        min-height: ${
          props.$isNewpriceHistory === true
            ? STATISTICS_MIN_HEIGHT_DESKTOP
            : STATISTICS_MIN_HEIGHT_DESKTOP_LEGACY
        };
      `}
    `}
  `
);
